import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-popup-model',
  templateUrl: './confirmation-popup-model.component.html',
  styleUrls: ['./confirmation-popup-model.component.scss']
})
export class ConfirmationPopupModelComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      cancelText: string,
      confirmText: string,
      message: string,
      title: string
    },
    private mdDialogRef: MatDialogRef<ConfirmationPopupModelComponent>
  ) { }

  ngOnInit() {
  }

  public cancel() {
    this.close(false);
  }
  public close(value) {
    this.mdDialogRef.close(value);
  }
  public confirm() {
    this.close(true);
  }
  @HostListener('keydown.esc')
  public onEsc() {
    this.close(false);
  }

}
